// core version, pagination modules:
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

const swiperE2 = document.querySelector( '.image-carousel .swiper' );
if ( swiperE2 ) {
	const isAutoplay = swiperE2.dataset.autoplay === 'true';
	// eslint-disable-next-line no-unused-vars
	new Swiper( swiperE2, {
		// configure Swiper to use modules.
		modules: [ Pagination, Autoplay ],
		// Default parameters.
		autoplay: isAutoplay ? { delay: 4500, disableOnInteraction: true } : false,
		slidesPerView: 1,
		speed: 400,
		loop: true,
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
		},
		spaceBetween: 24,
		// Responsive breakpoints.
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
		},
	} );
}
